var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NotiService } from '@app/noti.service';
import { ApiService } from '@app/utility/api.service';
import { UtilService } from '@app/utility/util.service';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
var CustomerType;
(function (CustomerType) {
    CustomerType[CustomerType["Company"] = 1] = "Company";
    CustomerType[CustomerType["Person"] = 2] = "Person";
})(CustomerType || (CustomerType = {}));
;
var RegisterComponent = /** @class */ (function () {
    function RegisterComponent(util, api, fb, apiService, activatedRoute, router, translate, notiService) {
        this.util = util;
        this.api = api;
        this.fb = fb;
        this.apiService = apiService;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.translate = translate;
        this.notiService = notiService;
        this.submitted = false;
        this.isShift = false;
        this.regisType = "n";
        this.Type = CustomerType.Person;
        this.isConsentAccept = false;
        this.isRequiredRegisId = false;
        this.isShownConsent = false;
        this.isDup = false;
        this.isSuccess = false;
        this.isForeign = false;
        this.strictIdCard = true;
        this.isCrisis = false;
        this.isIdCardValid = true;
        this.isNotInDROS = false;
        this.authFname = "";
        this.authLname = "";
        this.authIdcard = "";
        this.lang = "th";
        this.menuEnabled = false;
        this.form = this.fb.group({
            contactid: "",
            dpa_companyname: "",
            dpa_companytypeid: "",
            dpa_registrationid: "",
            dpa_authorizedperson: "",
            dpa_authorizedperson_idcard: "",
            dpa_authorizedperson_telephone: "",
            firstname: ['', Validators.required],
            lastname: ['', Validators.required],
            dpa_personaltypeid: '',
            dpa_personaltypeidname: "",
            birthdate: "",
            dpa_idcard: ['', Validators.required],
            dpa_accountno: ['', Validators.required],
            emailaddress1: ['', this.emailValidator],
            telephone1: ['', Validators.required],
            dpa_passport: "",
            dpa_contact_homeno: ['', Validators.required],
            dpa_contact_moo: "",
            dpa_contact_street: "",
            dpa_contact_subdistict: ['', Validators.required],
            dpa_contact_distict: "",
            dpa_contact_province: "",
            dpa_contact_postcode: "",
            dpa_contact_country: "",
            dpa_contact_subdistictname: "",
            dpa_contact_distictname: "",
            dpa_contact_provincename: "",
            dpa_contact_postcodename: "",
            dpa_contact_countryname: "",
            dpa_allowemail: false,
            dpa_allowsms: false,
            dpa_portalflag: true
        });
    }
    RegisterComponent.prototype.ngOnDestroy = function () {
        if (this.notiSubscription) {
            this.notiSubscription.unsubscribe();
        }
    };
    RegisterComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            function matchCustom(params, data) {
                if ($.trim(params.term) === '') {
                    return data;
                }
                if (typeof data.text === 'undefined') {
                    return null;
                }
                if (params.term.length > 1) {
                    var cris = params.term.split(" ");
                    var found = true;
                    for (var i = 0; i < cris.length; i++) {
                        if (cris[i] != '' && data != null && data.text != null && data.text.toLowerCase().indexOf(cris[i].toLowerCase()) < 0) {
                            found = false;
                            return null;
                        }
                    }
                    if (found) {
                        return data;
                    }
                }
                return null;
            }
            var thisTs, config, crisisConfig, menuList, thisMenu, para, tmp, type;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        thisTs = this;
                        this.util.ShowWaiting(true);
                        this.cookieData = JSON.parse(localStorage.getItem("dpa_portal"));
                        this.cookieData2 = JSON.parse(sessionStorage.getItem("dpa_portalThaiID"));
                        if (this.cookieData == null) {
                            this.cookieData = {};
                        }
                        if (this.cookieData2 != null) {
                            this.form.controls["firstname"].setValue(this.cookieData2.data.given_name);
                            this.form.controls["lastname"].setValue(this.cookieData2.data.family_name);
                            this.form.controls["dpa_idcard"].setValue(this.cookieData2.data.pid);
                            this.form.controls["telephone1"].setValue(this.cookieData2.data.phone);
                            this.form.controls["emailaddress1"].setValue(this.cookieData2.data.email);
                            this.form.controls["dpa_accountno"].setValue(this.cookieData2.data.accountno);
                            //let addr = this.cookieData2.address.split(" ");
                            //$(".select2").val(addr[2] + "|" + addr[3] + "|" + addr[4] + "|" + addr[5] + "|ประเทศไทย").trigger('change')
                            //this.formControl["dpa_contact_subdistict"].setValue(addr[1])
                            //this.formControl["dpa_contact_distict"].setValue(addr[2])
                            //this.formControl["dpa_contact_province"].setValue(addr[3])
                            //this.formControl["dpa_contact_postcode"].setValue(addr[4])
                            //this.formControl["dpa_contact_country"].setValue("ประเทศไทย")
                        }
                        return [4 /*yield*/, this.apiService.get("master", "configuration")];
                    case 1:
                        config = _a.sent();
                        crisisConfig = config.filter(function (c) {
                            return c.dpa_name == "CRISIS FLAG";
                        });
                        if (crisisConfig != null && crisisConfig.length > 0 && crisisConfig[0].dpa_crisisflag != null && crisisConfig[0].dpa_crisisflag == true) {
                            this.cookieData.isCrisis = true;
                            this.isCrisis = true;
                            localStorage.setItem("dpa_portal", JSON.stringify(this.cookieData));
                        }
                        else {
                            this.cookieData.isCrisis = false;
                            this.isCrisis = false;
                            localStorage.setItem("dpa_portal", JSON.stringify(this.cookieData));
                        }
                        return [4 /*yield*/, this.api.get("master", "customerPortalMenuSetting")];
                    case 2:
                        menuList = _a.sent();
                        thisMenu = this.util.getMenuObj(menuList, "11", this.isCrisis);
                        if (!thisMenu.show) {
                            this.util.ShowWaiting(false);
                            setTimeout(function () {
                                _this.router.navigate(["mainmenu/index"]);
                            }, 500);
                            return [2 /*return*/];
                        }
                        else {
                            this.menuEnabled = true;
                        }
                        // let tmpLang = this.util.GetCurrentLang()
                        // this.lang = tmpLang.substring(0,2)
                        // this.util.SetLanguage(tmpLang)
                        this.util.InitValidation();
                        para = "dpaCode=PRIVACY_POLICY";
                        return [4 /*yield*/, this.api.get("crmservice", "getPolicy", para)];
                    case 3:
                        tmp = _a.sent();
                        if (!this.util.IsNullOrUndefined(tmp.policyDetail)) {
                            $("#regPolicy").html(tmp.policyDetail);
                        }
                        // boy add
                        if (this.lang == "th") {
                            $(".select2-en").hide();
                            $(".select2-th").show();
                        }
                        else {
                            $(".select2-th").hide();
                            $(".select2-en").show();
                        }
                        this.notiSubscription = this.notiService.message.subscribe(function (_lang) {
                            _this.lang = _lang;
                            if (_this.lang == "th") {
                                $(".select2-en").hide();
                                $(".select2-th").show();
                            }
                            else {
                                $(".select2-th").hide();
                                $(".select2-en").show();
                            }
                            //this.bindAddress(this.lang)
                        });
                        type = this.activatedRoute.snapshot.queryParams['regisType'];
                        if (type == "c") {
                            this.regisType = "c";
                            this.Type = CustomerType.Company;
                        }
                        else {
                            this.regisType = "n";
                            this.Type = CustomerType.Person;
                        }
                        $('.select2th').select2({
                            matcher: matchCustom,
                            placeholder: "โปรดพิมพ์รายละเอียดที่อยู่"
                        });
                        $('.select2en').select2({
                            matcher: matchCustom,
                            placeholder: "Please select your address."
                        });
                        $(".select2").on("change", function (e) {
                            thisTs.addressChange(e.target.value);
                        });
                        this.initDropdown();
                        return [2 /*return*/];
                }
            });
        });
    };
    RegisterComponent.prototype.initDropdown = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (this.regisType == "n") {
                    Observable.forkJoin(this.apiService.get("master", "personalType"), this.apiService.getMasterAddress()).subscribe(function (data) {
                        _this.personalTypeList = data[0];
                        _this.combinedAddressList = data[1];
                        _this.setAddressEn();
                        _this.util.ShowWaiting(false);
                    }, function (err) { return console.error(err); });
                }
                else {
                    Observable.forkJoin(this.api.get("master", "companyType"), this.apiService.getMasterAddress()).subscribe(function (data) {
                        _this.companyTypeList = data[0];
                        _this.combinedAddressList = data[1];
                        _this.setAddressEn();
                        _this.util.ShowWaiting(false);
                    }, function (err) { return console.error(err); });
                }
                this.util.ShowWaiting(false);
                return [2 /*return*/];
            });
        });
    };
    RegisterComponent.prototype.setAddressEn = function () {
        if (this.combinedAddressList != null && this.combinedAddressList.length > 0) {
            this.combinedAddressListEn = this.combinedAddressList.slice().sort(function (a, b) {
                if (a.text_eng < b.text_eng) {
                    return -1;
                }
                if (a.text_eng > b.text_eng) {
                    return 1;
                }
                return 0;
            });
        }
    };
    Object.defineProperty(RegisterComponent.prototype, "formControl", {
        get: function () {
            return this.form.controls;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RegisterComponent.prototype, "email", {
        get: function () {
            return this.form.value.emailaddress1.trim();
        },
        enumerable: true,
        configurable: true
    });
    RegisterComponent.prototype.emailValidator = function (control) {
        if (control.value) {
            var matches = control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/);
            return matches ? null : { 'invalidEmail': true };
        }
        else {
            return null;
        }
    };
    RegisterComponent.prototype.addressChange = function (value) {
        var selected = this.combinedAddressList.filter(function (a) { return a.id == value; });
        if (selected != null && selected.length > 0) {
            var values = selected[0].id.split("|");
            var texts = void 0;
            if (this.lang == "th") {
                texts = selected[0].text.split(" | ");
            }
            else {
                texts = selected[0].text_eng.split(" | ");
            }
            this.formControl["dpa_contact_subdistict"].setValue(values[0]);
            this.formControl["dpa_contact_distict"].setValue(values[1]);
            this.formControl["dpa_contact_province"].setValue(values[2]);
            this.formControl["dpa_contact_postcode"].setValue(values[3]);
            this.formControl["dpa_contact_country"].setValue(values[4]);
            this.formControl["dpa_contact_subdistictname"].setValue(texts[0]);
            this.formControl["dpa_contact_distictname"].setValue(texts[1]);
            this.formControl["dpa_contact_provincename"].setValue(texts[2]);
            this.formControl["dpa_contact_postcodename"].setValue(texts[3]);
            this.formControl["dpa_contact_countryname"].setValue(texts[4]);
        }
        else {
            this.formControl["dpa_contact_subdistict"].setValue("");
            this.formControl["dpa_contact_distict"].setValue("");
            this.formControl["dpa_contact_province"].setValue("");
            this.formControl["dpa_contact_postcode"].setValue("");
            this.formControl["dpa_contact_country"].setValue("");
            this.formControl["dpa_contact_subdistictname"].setValue("");
            this.formControl["dpa_contact_distictname"].setValue("");
            this.formControl["dpa_contact_provincename"].setValue("");
            this.formControl["dpa_contact_postcodename"].setValue("");
            this.formControl["dpa_contact_countryname"].setValue("");
        }
    };
    RegisterComponent.prototype.clear = function () {
        this.submitted = false;
        $('#dob').val('');
        this.form.reset();
        $('.select2').val('').trigger('change');
    };
    RegisterComponent.prototype.preregister = function () {
        return __awaiter(this, void 0, void 0, function () {
            var thisTs, dpa_idcard, dpa_name_surname, dpa_birthday, dpa_accountno, emailaddress1, telephone1, dpa_contact_homeno, dpa_contact_moo, dpa_contact_street, dpa_contact_subdistictname, dpa_contact_distictname, dpa_contact_provincename, dpa_contact_postcodename, dpa_contact_countryname, listDataConfirm;
            return __generator(this, function (_a) {
                thisTs = this;
                dpa_idcard = "เลขบัตรประชาชน/เลขประจำตัวผู้เสียภาษี : " + this.form.controls["dpa_idcard"].value + "<br>";
                dpa_name_surname = "ชื่อ-นามสกุล : " + this.form.controls["firstname"].value + " " + this.form.controls["lastname"].value + "<br>";
                dpa_birthday = "วันเกิด : " + $("#dob").datepicker({ dateFormat: "dd/MM/yyyy" }).val() + "<br>";
                dpa_accountno = "เลขที่บัญชี : " + this.form.controls["dpa_accountno"].value + "<br>";
                emailaddress1 = "Email หลัก : " + this.form.controls["emailaddress1"].value + "<br>";
                telephone1 = "หมายเลขโทรศัพท์ : " + this.form.controls["telephone1"].value + "<br>";
                dpa_contact_homeno = "ที่อยู่ : " + this.form.controls["dpa_contact_homeno"].value + "<br>";
                dpa_contact_moo = "หมู่ที่ : " + this.form.controls["dpa_contact_moo"].value + "<br>";
                dpa_contact_street = "ถนน : " + this.form.controls["dpa_contact_street"].value + "<br>";
                dpa_contact_subdistictname = "แขวง/ตำบล : " + this.form.controls["dpa_contact_subdistictname"].value + "<br>";
                dpa_contact_distictname = "เขต/อำเภอ : " + this.form.controls["dpa_contact_distictname"].value + "<br>";
                dpa_contact_provincename = "จังหวัด : " + this.form.controls["dpa_contact_provincename"].value + "<br>";
                dpa_contact_postcodename = "รหัสไปรษณีย์ : " + this.form.controls["dpa_contact_postcodename"].value + "<br>";
                dpa_contact_countryname = "ประเทศ : " + this.form.controls["dpa_contact_countryname"].value + "<br><br>";
                listDataConfirm = dpa_idcard + dpa_name_surname + dpa_birthday + dpa_accountno + emailaddress1 + telephone1 +
                    dpa_contact_homeno + dpa_contact_moo + dpa_contact_street + dpa_contact_subdistictname +
                    dpa_contact_distictname + dpa_contact_provincename + dpa_contact_postcodename + dpa_contact_countryname;
                this.util.ConfirmDialog(listDataConfirm + "กรุณาตรวจสอบความครบถ้วนและความถูกต้องของข้อมูล ก่อนกดยืนยันการลงทะเบียน เพื่อให้สามารถเข้าใช้งานระบบได้อย่างสะดวก");
                $("#btnMainConfirm").off('click');
                $("#btnMainConfirm").click(function () {
                    return __awaiter(this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            thisTs.register();
                            return [2 /*return*/];
                        });
                    });
                });
                return [2 /*return*/];
            });
        });
    };
    RegisterComponent.prototype.register = function () {
        return __awaiter(this, void 0, void 0, function () {
            var contactId, thisTs_1, contactId, thisTs_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submitted = true;
                        this.isDup = false;
                        this.isSuccess = false;
                        this.isNotInDROS = false;
                        if (!(this.form.valid && this.isValidId())) return [3 /*break*/, 12];
                        this.util.ShowWaiting(true);
                        if (!(this.regisType == "n")) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.CreateContact()];
                    case 1:
                        contactId = _a.sent();
                        if (!(contactId != null && contactId.length > 0)) return [3 /*break*/, 3];
                        thisTs_1 = this;
                        //registerDROS
                        return [4 /*yield*/, this.registerDROS()];
                    case 2:
                        //registerDROS
                        _a.sent();
                        this.util.SuccessDialog("ลงทะเบียนสำเร็จ กรุณาตรวจสอบอีเมลของท่าน เพื่อยืนยันตัวตนและกำหนดรหัสผ่านในการเข้าใช้งานระบบ");
                        $('#btnSuccessOK').on('click', function () {
                            if (this.cookieData2 != null) {
                                sessionStorage.removeItem("dpa_portalThaiID");
                            }
                            thisTs_1.router.navigate(["mainmenu/index"]);
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        if (this.isForeign) {
                            this.form.controls["dpa_idcard"].setValue(this.form.get("dpa_passport").value);
                            this.form.controls["dpa_passport"].setValue("");
                            this.isForeign = false;
                        }
                        if (this.isDup) {
                            this.util.WarningDialog("อีเมลหรือบัตรประชาชนของท่าน ได้ลงทะเบียนใช้งานระบบแล้ว");
                        }
                        else if (this.isNotInDROS) {
                            this.util.WarningDialog("ไม่สามารถลงทะเบียนได้ กรุณาติดต่อ DPA Call Center 1158");
                        }
                        else {
                            this.util.ErrorDialog("ลงทะเบียนไม่สำเร็จ");
                        }
                        _a.label = 4;
                    case 4: return [3 /*break*/, 11];
                    case 5:
                        if (!this.isValidCompany()) return [3 /*break*/, 10];
                        return [4 /*yield*/, this.CreateContact()];
                    case 6:
                        contactId = _a.sent();
                        if (!(contactId != null && contactId.length > 0)) return [3 /*break*/, 8];
                        //registerDROS
                        return [4 /*yield*/, this.registerDROS()];
                    case 7:
                        //registerDROS
                        _a.sent();
                        this.util.SuccessDialog("ลงทะเบียนสำเร็จ");
                        thisTs_2 = this;
                        $('#btnSuccessOK').on('click', function () {
                            thisTs_2.router.navigate(["mainmenu/login"]);
                        });
                        return [3 /*break*/, 9];
                    case 8:
                        this.form.controls["firstname"].setValue(this.authFname);
                        this.form.controls["lastname"].setValue(this.authLname);
                        if (this.isForeign) {
                            this.form.controls["dpa_idcard"].setValue(this.form.get("dpa_passport").value);
                            this.form.controls["dpa_passport"].setValue("");
                            this.isForeign = false;
                        }
                        else {
                            this.form.controls["dpa_idcard"].setValue(this.authIdcard);
                        }
                        if (this.isDup) {
                            this.util.WarningDialog("อีเมลของท่านได้ลงทะเบียนใช้งานระบบแล้ว");
                        }
                        else if (this.isNotInDROS) {
                            this.util.WarningDialog("ไม่สามารถลงทะเบียนได้ กรุณาติดต่อ DPA Call Center 1158");
                        }
                        else {
                            this.util.ErrorDialog("ลงทะเบียนไม่สำเร็จ");
                        }
                        _a.label = 9;
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        this.util.WarningDialog("กรุณากรอกข้อมูลให้ถูกต้อง");
                        _a.label = 11;
                    case 11:
                        this.util.ShowWaiting(false);
                        return [3 /*break*/, 13];
                    case 12:
                        this.util.WarningDialog("กรุณากรอกข้อมูลให้ถูกต้อง");
                        _a.label = 13;
                    case 13: return [2 /*return*/];
                }
            });
        });
    };
    RegisterComponent.prototype.CreateContact = function () {
        return __awaiter(this, void 0, void 0, function () {
            var PortalUsername, dob, ContactID, Res, ResFlag, userType, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 7, , 8]);
                        if (this.Type == CustomerType.Person) {
                            if (this.form.get("dpa_personaltypeidname").value.includes("ต่างชาติ")) {
                                this.isForeign = true;
                                this.form.controls["dpa_passport"].setValue(this.form.get("dpa_idcard").value);
                                this.form.controls["dpa_idcard"].setValue("");
                            }
                            else {
                                this.form.controls["dpa_passport"].setValue("");
                            }
                        }
                        else {
                            // this.form.controls["dpa_contacttype"].setValue("3");
                            this.form.controls["dpa_authorizedperson"].setValue(this.form.get("firstname").value + " " + this.form.get("lastname").value);
                            this.form.controls["dpa_authorizedperson_idcard"].setValue(this.form.get("dpa_idcard").value);
                            this.form.controls["dpa_authorizedperson_telephone"].setValue(this.form.get("telephone1").value);
                            this.authFname = this.form.get("firstname").value;
                            this.authLname = this.form.get("lastname").value;
                            this.authIdcard = this.form.get("dpa_idcard").value;
                            this.form.controls["firstname"].setValue("");
                            this.form.controls["lastname"].setValue("");
                            this.form.controls["dpa_idcard"].setValue("");
                        }
                        dob = $('#dob').val();
                        if (dob == null || dob.trim().length == 0) {
                            this.formControl["birthdate"].setValue("");
                        }
                        else {
                            //this.formControl["birthdate"].setValue($('#dob').data('datepicker').date.toISOString())
                            this.formControl["birthdate"].setValue($("#dob").datepicker({ dateFormat: "dd/MM/yyyy" }).val());
                        }
                        ContactID = '';
                        return [4 /*yield*/, this.api.post("crmservice", "contact", this.form.value)];
                    case 1:
                        Res = _a.sent();
                        if (!(this.util.isSuccessResponse(Res) && Res["contactid"] != null && Res["contactid"] != "")) return [3 /*break*/, 5];
                        ContactID = Res["contactid"];
                        if (!(this.cookieData2 != null)) return [3 /*break*/, 3];
                        //sessionStorage.removeItem("dpa_portalThaiID"); UpdateFlagThaid
                        this.contactData = {
                            contactid: ContactID
                        };
                        return [4 /*yield*/, this.api.post("crmservice", "UpdateFlagThaid", this.contactData)];
                    case 2:
                        ResFlag = _a.sent();
                        _a.label = 3;
                    case 3:
                        userType = this.Type == CustomerType.Person ? "1" : "2";
                        if (this.Type == CustomerType.Person) {
                            this.PortalLogin = {
                                firstname: this.form.get("firstname").value,
                                lastname: this.form.get("lastname").value,
                                usernameidno: this.form.get("dpa_personaltypeidname").value.includes("ต่างชาติ") ? this.form.get("dpa_passport").value : this.form.get("dpa_idcard").value,
                                username: this.form.get("emailaddress1").value,
                                password: '',
                                passwordold1: '',
                                isactive: "1",
                                customerid: ContactID,
                                createOn: null,
                                createBy: null,
                                pid: null,
                                modifiedOn: null,
                                modifiedBy: null,
                                usertype: userType,
                                call_by: "2",
                                url: this.util.baseUrl()
                            };
                        }
                        else {
                            this.PortalLogin = {
                                firstname: this.form.controls["dpa_companyname"].value,
                                lastname: "",
                                usernameidno: Res["dpa_registrationid"],
                                username: this.form.get("emailaddress1").value,
                                password: '',
                                passwordold1: '',
                                isactive: "1",
                                customerid: ContactID,
                                createOn: null,
                                createBy: null,
                                pid: null,
                                modifiedOn: null,
                                modifiedBy: null,
                                usertype: userType,
                                call_by: "2",
                                url: this.util.baseUrl()
                            };
                        }
                        return [4 /*yield*/, this.apiService.postCustomApi("user", "InsertUser", this.PortalLogin)];
                    case 4:
                        Res = _a.sent();
                        //console.log(Res);
                        // let Token: any = {
                        //   username: this.PortalLogin.username,
                        //   usernameidno: this.PortalLogin.usernameidno,
                        //   usertype: this.Type == CustomerType.Person ? "1" : "2",
                        //   createBy: null//localStorage.getItem("AgentBank_Profile")
                        // };
                        // Res = await this.apiService.postCustomApi("user", "CreateToken", Token);
                        // if (Res != null) {
                        //   //let token: any = this.util.AesDecryptDictValue(Res.json())
                        //   Res = await this.SendEmail(Res["token_id"]);
                        // }
                        // //console.log(Res);
                        // //this.ResetForm();
                        // if(Res.code == "200"){
                        // }
                        return [2 /*return*/, ContactID];
                    case 5:
                        //check dup
                        if (Res["RESMSG"] != null && Res["RESMSG"] == "มีข้อมูลในระบบแล้ว") {
                            this.isDup = true;
                        }
                        else if (Res["RESMSG"] != null && Res["RESMSG"] == "ไม่มีข้อมูลDROS") {
                            this.isNotInDROS = true;
                        }
                        return [2 /*return*/, ''];
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        err_1 = _a.sent();
                        //console.log(err);
                        return [2 /*return*/, ''];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    RegisterComponent.prototype.SendEmail = function (TokenID) {
        return __awaiter(this, void 0, void 0, function () {
            var MailObj, url, MailContent, Res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        MailObj = {
                            contactid: this.PortalLogin.customerid,
                            dpa_name: this.PortalLogin.firstname + " " + this.PortalLogin.lastname
                        };
                        url = this.util.baseUrl() + "/resetPassword?id=" + TokenID;
                        MailContent = "เรียน คุณ" + this.PortalLogin.firstname + " " + this.PortalLogin.lastname + "<br /><br />" +
                            "   คุณได้ลงทะเบียนเพื่อเข้าใช้งานระบบ Customer Web Portal ของสถาบันคุ้มครองเงินฝาก <br />" +
                            "รหัสผู้ใช้งานคือหมายเลขบัตรประจำตัวประชาชน / หมายเลขผู้เสียภาษี โปรดคลิกลิงค์ด้านล่างเพื่อตั้งรหัสผ่าน <br /><br />" +
                            '<a target="_blank" href="' + url + '">' + url + "</a><br /><br />" +
                            "ขอแสดงความนับถือ <br />" +
                            "สถาบันคุ้มครองเงินฝาก <br />" +
                            "อาคารเอสเจ อินฟินิท วัน บิสซิเนสคอมเพล็กซ์ <br />" +
                            "ชั้น 25-27 เลขที่ 349 ถนนวิภาวดีรังสิต <br />" +
                            "แขวงจอมพล เขตจตุจักร กรุงเทพฯ 10900 <br />" +
                            "โทร : 02-272-0300";
                        MailObj.dpa_description = MailContent;
                        MailObj.dpa_callby = 2;
                        return [4 /*yield*/, this.apiService.post("crmservice", "sendEmail", MailObj)];
                    case 1:
                        Res = _a.sent();
                        return [2 /*return*/, Res];
                }
            });
        });
    };
    RegisterComponent.prototype.consentAcceptChange = function (target) {
        this.isConsentAccept = target.checked;
        if (!this.isShownConsent) {
            this.showConsent();
            this.isShownConsent = true;
        }
    };
    RegisterComponent.prototype.newsAllowChange = function (target) {
        this.form.controls["dpa_allowemail"].setValue(target.checked);
        this.form.controls["dpa_allowsms"].setValue(target.checked);
    };
    RegisterComponent.prototype.isValidCompany = function () {
        return this.formControl["dpa_companyname"].value != null &&
            this.formControl["dpa_companyname"].value.trim().length > 0 &&
            (!this.isRequiredRegisId || (this.isRequiredRegisId && this.formControl["dpa_registrationid"].value != null &&
                this.formControl["dpa_registrationid"].value.trim().length > 0));
    };
    RegisterComponent.prototype.CompanyTypeChange = function (value) {
        var Rec = this.companyTypeList.filter(function (a) { return a.dpa_companytypeid == value; });
        if (Rec != null && Rec.length > 0 &&
            (Rec[0]["dpa_name"] == "บริษัท จำกัด" || Rec[0]["dpa_name"] == "บริษัท(มหาชน) จำกัด" || Rec[0]["dpa_name"] == "ห้างหุ้นส่วนจำกัด")) {
            this.isRequiredRegisId = true;
        }
        else {
            this.isRequiredRegisId = false;
        }
    };
    RegisterComponent.prototype.numberdate = function (event) {
        var keyCode = (event.which) ? event.which : event.keyCode;
        var input = $('#dob').val();
        if (keyCode == 16) {
            this.isShift = true;
        }
        //Allow only Numeric Keys.
        if (((keyCode >= 48 && keyCode <= 57) || keyCode == 8 || keyCode <= 37 || keyCode <= 39 || (keyCode >= 96 && keyCode <= 105)) && this.isShift == false) {
            if ((input.length == 2 || input.length == 5) && keyCode != 8) {
                input += "/";
                $('#dob').val(input);
            }
            return true;
        }
        else {
            return false;
        }
    };
    RegisterComponent.prototype.telephoneOnly = function (event) {
        var charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            if (charCode == 35 || charCode == 44) {
                return true;
            }
            return false;
        }
        return true;
    };
    RegisterComponent.prototype.showConsent = function () {
        this.isShownConsent = true;
        $("#consentModal").modal('show');
    };
    RegisterComponent.prototype.personalTypeChange = function (value) {
        var type = this.personalTypeList.filter(function (p) {
            return value == p.dpa_personaltypeid;
        });
        if (type != null && type.length > 0) {
            this.formControl["dpa_personaltypeidname"].setValue(type[0].dpa_name);
            if (type[0].dpa_name == "ต่างชาติ") {
                this.strictIdCard = false;
            }
            else {
                this.strictIdCard = true;
            }
        }
        else {
            this.strictIdCard = true;
        }
    };
    RegisterComponent.prototype.idCardValidator = function (value) {
        if (value && value.length == 13) {
            var total = 0;
            var iPID;
            var chk;
            var Validchk;
            iPID = value.replace(/-/g, "");
            Validchk = iPID.substr(12, 1);
            var j = 0;
            var pidcut;
            for (var n = 0; n < 12; n++) {
                pidcut = parseInt(iPID.substr(j, 1));
                total = (total + ((pidcut) * (13 - n)));
                j++;
            }
            chk = 11 - (total % 11);
            if (chk == 10) {
                chk = 0;
            }
            else if (chk == 11) {
                chk = 1;
            }
            if (chk == Validchk) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return true;
        }
    };
    RegisterComponent.prototype.isValidId = function () {
        if (this.strictIdCard) {
            this.isIdCardValid = this.idCardValidator(this.formControl["dpa_idcard"].value);
            //return this.isIdCardValid //comment for test
            return true;
        }
        else {
            return true;
        }
    };
    RegisterComponent.prototype.numberAndAlphabetOnly = function (event) {
        var charCode = (event.which) ? event.which : event.keyCode;
        if (!(charCode > 47 && charCode < 58) && // numeric (0-9)
            !(charCode > 64 && charCode < 91) && // upper alpha (A-Z)
            !(charCode > 96 && charCode < 123)) {
            return false;
        }
        return true;
    };
    // bindAddress(lang: string){
    //   let v: any = this.translate.get("Select")
    //   this.ddlAddress.nativeElement.innerHtml = '<option value="">' + v.value +'</option>'
    //   this.combinedAddressList.forEach((a: any) => {
    //     if(lang == "th"){
    //       this.ddlAddress.nativeElement.innerHtml += '<option value="' + v.id + '">' + v.text + '</option>'
    //     }
    //     else{
    //       this.ddlAddress.nativeElement.innerHtml += '<option value="' + v.id + '">' + v.text_eng + '</option>'
    //     }
    //   });
    // }
    RegisterComponent.prototype.registerDROS = function () {
        return __awaiter(this, void 0, void 0, function () {
            var idcard, para, tmp, UID, SubdistictCode, PostalName, SubdistictObj, PostalObj, arrAddr, rowAddr, birthdateYYYYMMDD, rowSave, Res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        idcard = this.form.get("dpa_personaltypeidname").value.includes("ต่างชาติ") ? this.form.get("dpa_passport").value : this.form.get("dpa_idcard").value;
                        if (this.Type == CustomerType.Company) {
                            idcard = this.form.get("dpa_registrationid").value;
                        }
                        para = "dpa_id=" + idcard + "&telephoneno=&fullname=&CRM05=false&CRM04=false&CRM03=false&CRM02=false&CRM07=false&CRM06=true";
                        return [4 /*yield*/, this.apiService.get("crmservice", "contactDros", para)];
                    case 1:
                        tmp = _a.sent();
                        if (!!this.util.IsNullOrUndefined(tmp.CRM06)) return [3 /*break*/, 5];
                        UID = tmp.CRM06.UID;
                        SubdistictCode = "";
                        PostalName = "";
                        return [4 /*yield*/, this.apiService.postCustomApi("master", "Subdistrict", { id: this.form.get("dpa_contact_subdistict").value })];
                    case 2:
                        SubdistictObj = _a.sent();
                        return [4 /*yield*/, this.apiService.postCustomApi("master", "Postalcode", { id: this.form.get("dpa_contact_postcode").value })];
                    case 3:
                        PostalObj = _a.sent();
                        if (!this.util.IsNullOrUndefined(SubdistictObj)) {
                            SubdistictCode = SubdistictObj[0].dpa_code;
                        }
                        if (!this.util.IsNullOrUndefined(PostalObj)) {
                            PostalName = PostalObj[0].dpa_name;
                        }
                        arrAddr = [];
                        rowAddr = {
                            addressType: "2",
                            addressNo: this.form.get("dpa_contact_homeno").value,
                            villageName: null,
                            floor: null,
                            mooNo: this.form.get("dpa_contact_moo").value,
                            soiName: null,
                            streetName: this.form.get("dpa_contact_street").value,
                            locationCode: SubdistictCode,
                            zipcode: PostalName
                        };
                        birthdateYYYYMMDD = "";
                        if (this.form.get("birthdate").value != "") {
                            birthdateYYYYMMDD = moment(this.form.get("birthdate").value).format("YYYY/MM/DD");
                        }
                        arrAddr.push(rowAddr);
                        rowSave = {
                            uid: UID,
                            idNo: idcard,
                            title: null,
                            firstName: this.Type == CustomerType.Person ? this.form.get("firstname").value : this.form.controls["dpa_companyname"].value,
                            lastName: this.Type == CustomerType.Person ? this.form.get("lastname").value : "",
                            birthdate: birthdateYYYYMMDD,
                            mobileNo: this.Type == CustomerType.Person ? this.form.get("telephone1").value : this.form.get("dpa_authorizedperson_telephone").value,
                            email: this.form.get("emailaddress1").value,
                            address: arrAddr
                        };
                        return [4 /*yield*/, this.apiService.post("DROS", "register", rowSave)];
                    case 4:
                        Res = _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return RegisterComponent;
}());
export { RegisterComponent };



// WEBPACK FOOTER //
// ./src/app/register/register.component.ts.pre-build-optimizer.js